import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEventAccountQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetEventAccountQuery = { __typename?: 'Query', eventAccount?: { __typename?: 'EventAccount', id: string, external_zoho_id?: string | null, name?: string | null, description?: string | null, email?: string | null, send_order_fulfillment_emails: boolean, invoice_language: Types.InvoiceLanguage, is_billable: boolean, new_inventory_checks_are_non_billable: boolean, needs_purchasing_order_number: boolean, purchasing_order_email?: string | null, offline_card_checkout_limit?: number | null, return_deadline_days?: number | null, debitor_account_number: number, is_deleted: boolean, is_event_account: boolean, stores: Array<{ __typename?: 'Store', id: string, name?: string | null, banner?: string | null, permanently_removed?: boolean | null, address?: { __typename?: 'Address', streetname?: string | null, streetno?: string | null, zip?: string | null, city?: string | null } | null }>, users: Array<{ __typename?: 'EventAccountUser', id: string, name: string, password: string, can_do_order_fulfillments: boolean }>, participating_in_events?: Array<{ __typename?: 'Event', id: string, name?: string | null, image_url?: string | null, start_date?: string | null, end_date?: string | null, currency: string, is_deleted: boolean }> | null, item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string, event?: { __typename?: 'EventReduced', id?: string | null, name?: string | null } | null }> | null, authorized_signers: Array<{ __typename?: 'AuthorizedSigner', id: string, name: string, allowed_item_locations?: Array<{ __typename?: 'ItemLocation', id: string, event_id?: string | null }> | null }> } | null };


export const GetEventAccountDocument = gql`
    query getEventAccount($id: ID!) {
  eventAccount(id: $id) {
    id
    external_zoho_id
    name
    description
    email
    send_order_fulfillment_emails
    invoice_language
    is_billable
    new_inventory_checks_are_non_billable
    needs_purchasing_order_number
    purchasing_order_email
    offline_card_checkout_limit
    return_deadline_days
    external_zoho_id
    debitor_account_number
    is_deleted
    is_event_account
    stores {
      id
      name
      banner
      permanently_removed
      address {
        streetname
        streetno
        zip
        city
      }
    }
    users {
      id
      name
      password
      can_do_order_fulfillments
    }
    participating_in_events {
      id
      name
      image_url
      start_date
      end_date
      currency
      is_deleted
    }
    item_locations {
      id
      name
      event {
        id
        name
      }
    }
    authorized_signers {
      id
      name
      allowed_item_locations {
        id
        event_id
      }
    }
  }
}
    `;

/**
 * __useGetEventAccountQuery__
 *
 * To run a query within a React component, call `useGetEventAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventAccountQuery(baseOptions: Apollo.QueryHookOptions<GetEventAccountQuery, GetEventAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventAccountQuery, GetEventAccountQueryVariables>(GetEventAccountDocument, options);
      }
export function useGetEventAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventAccountQuery, GetEventAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventAccountQuery, GetEventAccountQueryVariables>(GetEventAccountDocument, options);
        }
export type GetEventAccountQueryHookResult = ReturnType<typeof useGetEventAccountQuery>;
export type GetEventAccountLazyQueryHookResult = ReturnType<typeof useGetEventAccountLazyQuery>;
export type GetEventAccountQueryResult = Apollo.QueryResult<GetEventAccountQuery, GetEventAccountQueryVariables>;